import {imgPlaceholder} from "../general";
import {useState} from "react";

export default props => {
  const [load, setLoad] = useState();
  const [error, setError] = useState();

  return <img
      {...({...props, ...(error || !props.src ? {src: imgPlaceholder.default} : [])})}
      onLoad={() => setLoad(true)}
      onError={() => setError(true)}
      style={{
        background: 'center no-repeat',
        backgroundImage: !(load || error) ? `url(${imgPlaceholder.default})` : undefined,
        backgroundSize: '100% 100%',
      }}/>
};